import { render, staticRenderFns } from "./HomeDirectorExtras.vue?vue&type=template&id=c2d8656c"
import script from "./HomeDirectorExtras.vue?vue&type=script&lang=js"
export * from "./HomeDirectorExtras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports